
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/sign-in",
      function () {
        return require("private-next-pages/auth/sign-in.tsx");
      }
    ]);
  